import { ProductCode } from '@dev/ee-api/ee-api-models';
import { DashboardPaths } from '@/services/dictionaries/Paths';

export const getProductUrl = (code: ProductCode): string => DashboardPaths?.[code] || '/404';
